import { GridsterItem } from 'angular-gridster2';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { dynamicComponent, dynamicComponentsInputs } from './dashboard.config';
import { availableColors, chartLineColor } from '../shared/charts/chart.config';
import { callVolumeChartConfig } from './call-volume-chart.config';

export enum DashboardInboundWidgets {
  abandonment_rate = 'abandonment_rate',
  sla = 'sla',
  inbound_calls = 'inbound_calls',
  outbound_calls = 'outbound_calls',
  call_queue = 'call_queue',
  users = 'users'
}

export const inboundDashboard: GridsterItem[] = [
  {
    cols: 2,
    rows: 2,
    y: 3,
    x: 0,
    title: 'INBOUND_DASHBOARD.USERS',
    id: DashboardInboundWidgets.users,
    component: dynamicComponent.UsersComponent,
    inputs: {
      results: new BehaviorSubject(dynamicComponentsInputs[dynamicComponent.UsersComponent])
    }
  },
  {
    cols: 2,
    rows: 2,
    y: 3,
    x: 2,
    title: 'INBOUND_DASHBOARD.CALL_QUEUE',
    tooltip: {
      text: 'INBOUND_DASHBOARD.CALL_QUEUE_TOOLTIP'
    },
    id: DashboardInboundWidgets.call_queue,
    component: dynamicComponent.CallQueueComponent,
    inputs: {
      results: new BehaviorSubject([])
    }
  },
  {
    cols: 2,
    rows: 3,
    y: 0,
    x: 0,
    title: 'INBOUND_DASHBOARD.INBOUND_CALL_VOLUME',
    showLast30days: true,
    tooltip: {
      text: 'INBOUND_DASHBOARD.INBOUND_CALL_VOLUME_TOOLTIP'
    },
    id: DashboardInboundWidgets.inbound_calls,
    component: dynamicComponent.InboundCallsComponent,
    inputs: {
      results: new BehaviorSubject({
        data: { all: [], answered: [] },
        labelAll: 'INBOUND_DASHBOARD.INBOUND_CALLS',
        labelAnswered: 'INBOUND_DASHBOARD.ANSWERED_CALLS'
      }),
      colors: [chartLineColor[availableColors.blue], chartLineColor[availableColors.darkBlue]],
      config: callVolumeChartConfig
    }
  },
  {
    cols: 2,
    rows: 3,
    y: 0,
    x: 2,
    title: 'INBOUND_DASHBOARD.OUTBOUND_CALL_VOLUME',
    showLast30days: true,
    tooltip: {
      text: 'INBOUND_DASHBOARD.OUTBOUND_CALL_VOLUME_TOOLTIP'
    },
    id: DashboardInboundWidgets.outbound_calls,
    component: dynamicComponent.OutboundCallsComponent,
    inputs: {
      results: new BehaviorSubject({
        data: { all: [], answered: [] },
        labelAll: 'INBOUND_DASHBOARD.INBOUND_CALLS',
        labelAnswered: 'INBOUND_DASHBOARD.ANSWERED_CALLS'
      }),
      colors: [chartLineColor[availableColors.green], chartLineColor[availableColors.nightGreen]],
      config: callVolumeChartConfig
    }
  }
];

export const getWidget = (dashboard: any[], id: DashboardInboundWidgets): GridsterItem => {
  return dashboard.find((el: { id: DashboardInboundWidgets }) => el.id === id);
};
